import { FC } from 'react';
import LoadingIndicator from '../../loading/LoadingIndicator';
import Theme from '../../Theme';

interface Props {
  onClick: () => void;
  loading: boolean;
}

const ApplePayButton: FC<Props> = ({ onClick, loading }) => {
  return (
    <button
      onClick={onClick}
      className="apple-pay-button-with-text apple-pay-button-black-with-text w-full h-[40px] flex items-end justify-end"
    >
      {loading && <LoadingIndicator lg={18} md={18} sm={18} customColor={Theme.color.white.DEFAULT} />}
    </button>
  );
};

export default ApplePayButton;
